import React from "react";

// reactstrap components
import {
    Alert,
    Button,
    Card,
    CardHeader,
    Col,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    CardFooter,
    Pagination,
    PaginationItem,
    PaginationLink,
    Container,
    Row,
} from "reactstrap";
// core components
import ReactDatetime from "react-datetime";
import * as moment from "moment";
import CreditReports from "components/Tables/CreditReport";
import Header from "components/Headers/CreditReportHeader";
import CreditDataService from "../../services/CreditDataService";

class CreditReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultModal: false,
            reports: [],
            perPage: 10,
            currentPage: 1,
        };
        this.CreditDataService = new CreditDataService();
    }

    componentDidMount() {
        this.fetchData()
    }

    onDateChanged(e, dateFieldType) {
        var date = new Date(e._d);
        if (dateFieldType === 'endDate') {
            date.setHours(23, 59, 59, 59);
        }
        this.setState({
            [dateFieldType]: moment(date.toISOString(), 'YYYY-MM-DDTHH:mm:ss.sssZ').format('YYYY-MM-DD HH:mm:ss'),
            currentPage: 1,
        });
    }

    handleExport(isUnion, item) {
        this.CreditDataService.exportReport(this.state.startDate, this.state.endDate, isUnion, item?.report_id).then((data) => {
            this.setState(data)
        });
    }

    handleExportById(item, isUnion) {
        if (isUnion) {
            this.handleExport(isUnion, item)
        } else {
            this.CreditDataService.exportReportById(item.report_id).then((data) => {
                this.setState(data)
            });
        }
    }

    fetchData() {
        this.CreditDataService
            .getReports(this.state.currentPage, this.state.perPage)
            .then(res => {
                this.setState(res)
            });
    }

    handlePageClick = (e) => {
        const selectedPage = e;

        this.setState({
            currentPage: selectedPage,
        }, () => {
            this.fetchData()
        });
    }

    handleNextPageClick() {
        this.handlePageClick(this.state.currentPage + 1)
    }

    handlePreviousPageClick() {
        this.handlePageClick(this.state.currentPage - 1)
    }

    handleProceed(item) {
        this.CreditDataService.proceedReport(item.report_id).then(data => {
            if (data.data?.errorMessage === undefined) {
                this.setState( { successMessage: 'Proceed report berhasil.'}, () => {
                    this.fetchData();
                })
            } else {
                this.setState({ errorMessage: data.data.errorMessage })
            }

            setTimeout(() => {
                this.setState({ errorMessage: undefined, successMessage: undefined })
            }, 5000);
        });
    }

    render() {
        const pageNumbers = [];
        for (var index = 1; index <= this.state.totalPages; index++) {
            pageNumbers.push(index)
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <PaginationItem className={this.state.currentPage === number ? "active" : ""}>
                    <PaginationLink
                        onClick={() => this.handlePageClick(number)}
                    >
                        {number}
                    </PaginationLink>
                </PaginationItem>
            )
        })

        return (
            <>
                <Header />
                {/* Page content */}
                <Container className="mt--7" fluid>
                    {/* Table */}
                    <Row>
                        <div className="col">
                            <Card className="shadow">
                                <CardHeader className="border-0">
                                    <Row className="align-items-center">
                                        <Col className="text-right" xs="4">
                                        </Col>
                                        {this.state.errorMessage && (
                                            <Col xs="12" className="mt-5">
                                                <Alert color="danger">
                                                    {this.state.errorMessage}
                                                </Alert>
                                            </Col>
                                        )}
                                        {this.state.successMessage && (
                                            <Col xs="12" className="mt-5">
                                                <Alert color="success">
                                                    {this.state.successMessage}
                                                </Alert>
                                            </Col>
                                        )}
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xs={4}>
                                            <Row>
                                                <Col xs={6}>
                                                    <FormGroup>
                                                        <InputGroup className="input-group-alternative">
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>
                                                                    <i className="ni ni-calendar-grid-58" />
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <ReactDatetime
                                                                inputProps={{
                                                                    placeholder: "Dari tanggal"
                                                                }}
                                                                range="start"
                                                                timeFormat={false}
                                                                renderDay={(props, currentDate, selectedDate) => {
                                                                    let classes = props.className;
                                                                    if (
                                                                        this.state.startDate &&
                                                                        this.state.endDate &&
                                                                        this.state.startDate._d + "" === currentDate._d + ""
                                                                    ) {
                                                                        classes += " start-date";
                                                                    } else if (
                                                                        this.state.startDate &&
                                                                        this.state.endDate &&
                                                                        new Date(this.state.startDate._d + "") <
                                                                        new Date(currentDate._d + "") &&
                                                                        new Date(this.state.endDate._d + "") >
                                                                        new Date(currentDate._d + "")
                                                                    ) {
                                                                        classes += " middle-date";
                                                                    } else if (
                                                                        this.state.endDate &&
                                                                        this.state.endDate._d + "" === currentDate._d + ""
                                                                    ) {
                                                                        classes += " end-date";
                                                                    }
                                                                    return (
                                                                        <td {...props} className={classes}>
                                                                            {currentDate.date()}
                                                                        </td>
                                                                    );
                                                                }}
                                                                onChange={(e) => this.onDateChanged(e, "startDate")}
                                                            // onChange={e => this.setState({ startDate: e })}
                                                            />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                                <Col xs={6} className="ml-n4">
                                                    <FormGroup>
                                                        <InputGroup className="input-group-alternative">
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>
                                                                    <i className="ni ni-calendar-grid-58" />
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <ReactDatetime
                                                                inputProps={{
                                                                    placeholder: "Hingga tanggal"
                                                                }}
                                                                range="end"
                                                                timeFormat={false}
                                                                value={this.state.endDate}
                                                                renderDay={(props, currentDate, selectedDate) => {
                                                                    let classes = props.className;
                                                                    if (
                                                                        this.state.startDate &&
                                                                        this.state.endDate &&
                                                                        this.state.startDate._d + "" === currentDate._d + ""
                                                                    ) {
                                                                        classes += " start-date";
                                                                    } else if (
                                                                        this.state.startDate &&
                                                                        this.state.endDate &&
                                                                        new Date(this.state.startDate._d + "") <
                                                                        new Date(currentDate._d + "") &&
                                                                        new Date(this.state.endDate._d + "") >
                                                                        new Date(currentDate._d + "")
                                                                    ) {
                                                                        classes += " middle-date";
                                                                    } else if (
                                                                        this.state.endDate &&
                                                                        this.state.endDate._d + "" === currentDate._d + ""
                                                                    ) {
                                                                        classes += " end-date";
                                                                    }
                                                                    return (
                                                                        <td {...props} className={classes}>
                                                                            {currentDate.date()}
                                                                        </td>
                                                                    );
                                                                }}
                                                                onChange={(e) => this.onDateChanged(e, "endDate")}
                                                            />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={6} className="ml-n4">
                                            <Row>
                                            <Col xs={5} className="ml-n4">
                                                <Button
                                                    color="danger"
                                                    size="md"
                                                    onClick={() => this.handleExport()}
                                                >
                                                    Generate report
                                                </Button>
                                            </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CreditReports
                                    items={this.state.reports}
                                    handleProceed={this.handleProceed.bind(this)}
                                    handleExportById={this.handleExportById.bind(this)}
                                    fetchData={this.fetchData.bind(this)}
                                    isLunasi={false}
                                />
                                <CardFooter className="py-4">
                                    <nav aria-label="...">
                                        <Pagination
                                            className="pagination justify-content-end mb-0"
                                            listClassName="justify-content-end mb-0"
                                        >
                                            <PaginationItem className={this.state.currentPage === 1 && "disabled"}>
                                                <PaginationLink
                                                    onClick={() => this.handlePreviousPageClick()}
                                                    tabIndex="-1"
                                                >
                                                    <i className="fas fa-angle-left" />
                                                    <span className="sr-only">Previous</span>
                                                </PaginationLink>
                                            </PaginationItem>
                                            {renderPageNumbers}
                                            <PaginationItem className={this.state.currentPage === this.state.totalPages && "disabled"}>
                                                <PaginationLink
                                                    onClick={() => this.handleNextPageClick()}
                                                >
                                                    <i className="fas fa-angle-right" />
                                                    <span className="sr-only">Next</span>
                                                </PaginationLink>
                                            </PaginationItem>
                                        </Pagination>
                                    </nav>
                                </CardFooter>
                            </Card>
                        </div>
                    </Row>
                </Container>
            </>
        );
    }
}

export default CreditReport;
